<button
  class="scroll-top-button"
  type="button"
  *ngIf="isVisible"
  (click)="scrollToTop()"
  aria-label="Scroll to top"
  title="Scroll to top"
  [style.--scroll-progress]="scrollProgress + '%'"
>
  <span class="scroll-top-button__inner">
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 19V5M5.5 11.5 12 5l6.5 6.5" />
    </svg>
  </span>
</button>
